import { EMPTY_LIST } from '../../../../constants/common'

export const ENTITY_TAB_BUILDINGS_EDIT_MODAL_QA_NAME =
  'editStaffMemberBuildings'

export const ENTITY_TAB_BUILDINGS_EDIT_MODAL_FIELD_NAME_BUILDINGS = 'buildings'

export const ENTITY_TAB_BUILDINGS_EDIT_MODAL_EMPTY_VALUES = {
  [ENTITY_TAB_BUILDINGS_EDIT_MODAL_FIELD_NAME_BUILDINGS]: EMPTY_LIST,
}

// `building-options/` has its own filter vocabulary with no `staff_member`
// key; the staff scope maps to the responsible-manager relation there.
export const ENTITY_TAB_BUILDINGS_EDIT_MODAL_OPTIONS_FILTER_KEY_BY_SCOPE_KEY = {
  staff_member: 'responsible_user',
}
